const getDefaultState = () => {
    return {
        items: [],
    }
};

const state = getDefaultState();

const getters = {
    byId: (state) => (id) => {
        return state.items[id];
    },
    styleClass: () => (id) => {
        let classes;
        switch (parseInt(id)) {
            case 0:
                classes = "grey darken-4";
                break;
            case 1:
                classes = "grey--text";
                break;
            case 2:
                classes = "yellow black--text";
                break;
            case 3:
                classes = "orange black--text";
                break;
            case 5:
                classes = "red darken-3 black--text";
                break;
            case 6:
                classes = "blue darken-1";
                break;
            case 7:
                classes = "grey darken-3";
                break;
            case 8:
                classes = "yellow lighten-3 black--text";
                break;
            case 9:
                classes = "gray--text";
                break;
            case 10:
                classes = "gray--text";
                break;
        }
        return classes;
    }
};

const actions = {
};

const mutations = {
    set(state, payload) {
        state.items = payload;
    },
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
